import React, { ReactElement } from 'react'
import { Link, Space, TextBody } from '@ally/metronome-ui'

export function SdaWithDisabledSsBoosterNotif(
  accountDetailsLink: string,
): ReactElement {
  return (
    <Space pb="sm">
      <TextBody tag="p" size="md">
        We need to reconnect the account you use to power your Surprise Savings.
        Go to your{' '}
        <Link
          to={accountDetailsLink}
          text="savings account"
          aria-label="savings account"
          withAllyTM="savingsAccount"
        />{' '}
        and select{' '}
        <TextBody tag="span" size="md" weight="bold">
          Manage Accounts
        </TextBody>
        .
      </TextBody>
    </Space>
  )
}
